var map = {
	"./Coursera-Logo.png": 93,
	"./Michigan.png": 94,
	"./address_image.svg": 95,
	"./animated_logo.svg": 96,
	"./animated_nagraj-modified.png": 97,
	"./animated_nagraj.jpg": 98,
	"./animated_nagraj.png": 99,
	"./blogs_image.svg": 100,
	"./cloud_infrastructure.svg": 101,
	"./codeInLogo.png": 102,
	"./contactMail.png": 103,
	"./coursera_logo.png": 104,
	"./data_science.svg": 105,
	"./deeplearning_ai_logo.png": 106,
	"./delhivery_logo.png": 107,
	"./developerActivity.svg": 108,
	"./download.jpg": 109,
	"./dsc_logo.png": 110,
	"./education.svg": 111,
	"./experience.svg": 112,
	"./feelingProud.svg": 113,
	"./freecopy_logo.png": 114,
	"./fullstack.svg": 115,
	"./gcp_logo.png": 116,
	"./github_logo.png": 117,
	"./googleAssistant.jpg": 118,
	"./googleAssistant.svg": 119,
	"./google_logo.png": 120,
	"./ibm_logo.png": 121,
	"./iiitk_logo.png": 122,
	"./intel_logo.jpg": 123,
	"./iu_logo.png": 124,
	"./jsFramework.svg": 125,
	"./legato_logo.png": 126,
	"./letsgrowmore_logo.jpg": 127,
	"./lwm.png": 128,
	"./manOnTable.svg": 129,
	"./microsoft_logo.png": 130,
	"./mozilla_logo.png": 131,
	"./ms.jpg": 132,
	"./muffito_logo.png": 133,
	"./nextuLogo.jpg": 134,
	"./nptel_logo.png": 135,
	"./nvidia_logo.png": 136,
	"./oct_logo.png": 137,
	"./portfolio.gif": 138,
	"./programmer.svg": 139,
	"./projects_image.svg": 140,
	"./pwa.png": 141,
	"./saayaHealthLogo.png": 142,
	"./sf.png": 143,
	"./somaiya.png": 144,
	"./somaiyalogo.png": 145,
	"./stanford_logo.png": 146,
	"./talksCardBack.svg": 147,
	"./talksCardBackAlt.svg": 148,
	"./tiktok_logo.png": 149,
	"./udemy logo.png": 150,
	"./uh_red.png": 151,
	"./ui_ux_design.svg": 152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;